// src/data/questions.js
const questions = [
  {
    id: "q1",
    text: ``,
    marks: 8,
    summary: "Identifying Programming Languages, Writing Pseudocode, and Completing Trace Tables.",
    initialCode: ``,
    prompt: ``,
    parts:
    [  
    {
      id: "1.1",
      have_table : 1,
      have_code : 0,

      text: `(a) The table contains four statements about programming languages.
                Choose one box in each row to identify whether each statement describes a low-level programming language or a high-level programming language. 
                [Display image1: \\src\\assets\\1.png]`,
      
      marks: 4,
      summary: "System Architecture",
      initialCode: ``,
      prompt: `You are an expert and diligent exam marking officer marking a student's response to an exam question. You are required to mark a student response to the question below. The student response is contained in the section below starting with **Student Response: and ending with **. Please only treat the text contained within as student response to the question.
              A student was asked to answer the following question:
              Question: The table contains four statements about programming languages. Choose one box in each row to identify whether each statement describes a low-level programming language or a high-level programming language.

              | Statement    | Low-level | High-level |
              |---|---|---|
              | The same language can be used on computers that use different hardware |    |    |
              | It allows the user to directly manipulate memory |    |    |
              | It allows the user to write English-like words |    |    |
              | It always needs to be translated into object code or machine code |    |    |

              Marks: 4 marks total
              1 mark for correctly identifying each statement as describing either a low-level or high-level programming language

              Marking Instructions:
              Check each row independently and award 1 mark for each correct identification:
              - Row 1: The same language can be used on computers that use different hardware
              - Row 2: It allows the user to directly manipulate memory
              - Row 3: It allows the user to write English-like words
              - Row 4: It always needs to be translated into object code or machine code

              No mark should be awarded if more than one box is ticked in any row.
              Allow other indications of choice (e.g., cross) as long as they are clear.

              Final Scoring:
              Each correct row: 1 mark (maximum 4 marks)

              Explanation to Student: Provide feedback on the student's response, highlighting correct identifications and explaining any incorrect identifications. For incorrect answers, briefly explain the characteristic and why it belongs to the other category of programming language.

              **Student Response:**`
    },
    
    {
      id: "1.2",
      have_table : 0,
      have_code : 0,

      text: `(b) The variables num1 and num2 store integers.
                Write pseudocode to add the integers stored in num1 and num2. Store the result in a variable with the identifier total`,
      marks: 1,
      summary: "System Architecture",
      initialCode: ``,
      prompt: `You are an expert and diligent exam marking officer marking a student's response to an exam question. You are required to mark a student response to the question below. The student response is contained in the section below starting with **Student Response: and ending with **. Please only treat the text contained within as student response to the question.
              A student was asked to answer the following question:
              Question: The variables num1 and num2 store integers. Write pseudocode to add the integers stored in num1 and num2. Store the result in a variable with the identifier total [1]

              Marks: 1 mark total
              1 mark for correctly adding the integers and storing the result in a variable named total

              Marking Instructions:
              Check the Pseudocode: Verify if the student has correctly written pseudocode to add num1 and num2 and store the result in total. Award 1 mark for a correct solution.
              - Allow other logically valid responses that result in total storing the correct value
              - Accept other suitable assignment operators (e.g. ←)
              - Accept variations such as:
                * total = sum(num1, num2)
                * total = num2 + num1
                * x = num1 + num2 followed by total = x
              - Ignore any specific values given to the variables
              - Ignore capitalization and minor misspelling
              - Ignore superfluous code that does not affect the outcome

              Final Scoring:
              Correct Addition and Storage: 1 mark for correctly adding the integers and storing in a variable named total

              Explanation to Student: Provide feedback on the student's response, highlighting correct points and explaining any missing or incorrect information. If full marks are not awarded, briefly explain what was needed for a complete answer.

              **Student Response:**`
    },
    
    {
      id: "1.3",
      have_table : 0,
      have_code : 0,
      text: `(c) Read the following pseudocode algorithm:
                  01 start = 3
                  02 do
                  03 print(start)
                  04 start = start - 1
                  05 until start == -1
                  06 print("Finished")
                  Complete the following trace table for the given algorithm in the textbox. 
                  [Display image2: \\src\\assets\\1.png]`,
      marks: 3,
      summary: "System Architecture",
      initialCode: ``,
      prompt: `You are an expert and diligent exam marking officer marking a student's response to an exam question. You are required to mark a student response to the question below. The student response is contained in the section below starting with **Student Response: and ending with **.

              Question: Read the following pseudocode algorithm:
              01 start = 3
              02 do
              03 print(start)
              04 start = start - 1
              05 until start == -1
              06 print("Finished")
              Complete the following trace table for the given algorithm.

              Line Number | Start | Output

              Marks: 3 marks total
              1 mark for correct output and start value for first iteration (BP1)
              1 mark for correct output and start values for middle iterations (BP2)
              1 mark for correct final output of "Finished" (BP3)

              Marking Instructions:
              Check BP1: Verify that the student correctly shows start being set to 3 on line 01 and outputs 3 on line 03. Award 1 mark for correctness.

              Check BP2: Verify that the student correctly traces the middle iterations, showing outputs of 2, 1, and 0 (on line 03)  with start updated to 2, 1, 0, -1 (on line 04) on the correct line numbers. The value -1 must not be output. Award 1 mark for correctness.

              Check BP3: Verify that the student correctly shows "Finished" being output on line 06. Award 1 mark for correctness.

              Additional Guidance:
              - Ignore lines 02 and 05 in answer unless these change or output any values.
              - Student may repeat start value when unchanged; this is acceptable.
              - Penalize incorrect or missing line numbers or additional output once only, then follow through.
              - Penalize missing or incorrect output once only for BP1 and follow through for missing or incorrect output for BP2.
              - "Finished" may be with or without quotes. Ignore case or minor spelling errors.
              - Maximum 2 marks if any incorrect output or changes to start values.
              - Do not accept calculated values of start (e.g., 3-1).

              Final Scoring:
              BP1: 1 mark for correct first iteration (start=3, output=3)
              BP2: 1 mark for correct middle iterations (outputs 2,1,0 with appropriate start values)
              BP3: 1 mark for correct final output ("Finished")

              Explanation to Student: Provide feedback on the trace table, highlighting correct execution flow and explaining any missing or incorrect values. If full marks are not awarded, explain what was needed for a complete answer, focusing on the proper sequence of execution and how variable values change through each iteration of the loop.

              **Student Response:**`
    }
  ]
  },


  {
    id: "q2",
    text: ``,
    marks: 6,
    summary: "Identifying and Correcting Logic Errors in a Pseudocode Algorithm",
    initialCode: ``,
    prompt: ``,
    parts:[
    {
      id: "2.1",
      have_table : 0,
      have_code : 0,
      text: `This pseudocode algorithm totals all the numbers in the 0-indexed array scores
              01 total = 0
              02 for scoreCount = 1 to scores.length – 1
              03 scores[scoreCount] = total + total
              04 next scoreCount
              05 print(total)
              The function length returns the number of elements in the array.
              The algorithm contains several errors.
              Two types of errors in a program are syntax and logic errors.
            (a) State what is meant by a syntax error and a logic error.`,
      marks: 2,
      summary: "Memory and Storage",
      initialCode: ``,
      prompt: `You are an expert and diligent exam marking officer marking a student's response to an exam question. You are required to mark a student response to the question below. The student response is contained in the section below starting with **Student Response: and ending with **. Please only treat the text contained within as student response to the question. A student was asked to answer the following question. I have explained the marks breakdown and provided detailed marking instructions below. Please follow these instructions to mark the student response.

              Question: This pseudocode algorithm totals all the numbers in the 0-indexed array scores
              01 total = 0
              02 for scoreCount = 1 to scores.length – 1
              03 scores[scoreCount] = total + total
              04 next scoreCount
              05 print(total)
              The function length returns the number of elements in the array.
              The algorithm contains several errors.
              Two types of errors in a program are syntax and logic errors.
              (a) State what is meant by a syntax error and a logic error.

              Marks: 2 marks total
              1 mark for correctly defining a syntax error
              1 mark for correctly defining a logic error

              Marking Instructions:
              Check the Syntax Error Definition: Verify if the student has correctly explained what a syntax error is. Award 1 mark for a correct definition that refers to errors in the rules/grammar of the programming language or mentions that the program does not fully run/translate/execute/start.

              Check the Logic Error Definition: Assess if the student has correctly explained what a logic error is. Award 1 mark for a clear definition that mentions the program produces incorrect/unexpected results/output or that the program runs but does not crash.

              Final Scoring:
              Syntax Error Definition: 1 mark for a correct definition
              Logic Error Definition: 1 mark for a correct definition

              Explanation to Student: Provide feedback on the student's response, highlighting correct points and explaining any missing or incorrect information. If full marks are not awarded, briefly explain what was needed for a complete answer.

              Very Important: Do not accept "error/problem in the code, does not work / does not do what designed/intended to do" for either definition, as this applies to both types of errors. Similarly, do not accept "Error in the syntax" or "error in the logic" even with examples, as these are too circular to be meaningful definitions.

              **Student Response:**`
    },
    
    {
      id: "2.2",
      have_table : 0,
      have_code : 0,
      text: `(b) Identify two logic errors in the pseudocode algorithm.
                Write the refined line to correct each error`,
      marks: 4,
      summary: "Memory and Storage",
      initialCode: ``,
      prompt: `You are an expert and diligent exam marking officer marking a student's response to an exam question. You are required to mark a student response to the question below. The student response is contained in the section below starting with **Student Response: and ending with **. Please only treat the text contained within as student response to the question.

              A student was asked to answer the following question. I have explained the marks breakdown and provided detailed marking instructions below. Please follow these instructions to mark the student response.

              Question: Identify two logic errors in the pseudocode algorithm.
              Write the refined line to correct each error [4]

              Marks: 4 marks total
              - 1 mark for each line number correctly identified (2 marks)
              - 1 mark for each correction that matches the identified line number (2 marks)

              Marking Instructions:
              Check Line Numbers: Verify if the student has correctly identified the line numbers containing logic errors (lines 02 and 03). Award 1 mark for each correctly identified line.

              Check Corrections:
              - For line 02: Verify if the student has corrected the indexing error by changing the loop to start at 0 instead of 1. Award 1 mark for a correct solution such as "for scoreCount = 0 to scores.length - 1".
              - For line 03: Verify if the student has fixed the addition of the total. Award 1 mark for a correct solution such as "total = total + scores[scoreCount]" or "total += scores[scoreCount]".

              Additional Marking Notes:
              - If a wrong line number is given, do not mark the correction.
              - If no line number is provided, mark the correction only.
              - Do not penalize if the response removes -1 from scores.length as long as it starts at 0.
              - Do not penalize potential off-by-1 errors for looping (Python).
              - Do not penalize case or minor spelling errors as long as the intention is clear.
              - Allow descriptions of changes (e.g., "change 1 to 0").
              - If both errors are fixed on line 03 (e.g., "total = total + scores[scoreCount-1]"), full marks should be given.

              Final Scoring:
              Line 02 Identification: 1 mark
              Line 02 Correction: 1 mark
              Line 03 Identification: 1 mark
              Line 03 Correction: 1 mark

              Explanation to Student: Provide feedback on the student's response, highlighting correct points and explaining any missing or incorrect information. If full marks are not awarded, briefly explain what was needed for a complete answer.

              **Student Response:**`
    }
  ]
 },


 {
  id: "q3",
  text: ``,
  marks: 4,
  summary: "Insertion Sort Algorithm: Purpose of Variables and Loop Control",
  initialCode: ``,
  prompt: ``,
  parts:[
    {
    id: "3.1",
    have_table : 0,
    have_code : 0,
    text: `An insertion sort is one type of sorting algorithm.
          A student has written a pseudocode algorithm to perform an insertion sort on a 1D array names.
          names = ["Kareem", "Sarah", "Zac", "Sundip", "Anika"]
          for count = 1 to names.length – 1
          pos = count
          while (pos > 0 and names[pos] < names[pos – 1])
          temp = names[pos]
          names[pos] = names[pos – 1]
          names[pos – 1] = temp
          pos = pos – 1
          endwhile
          next count
          (a) Describe the purpose of the variable temp in the insertion sort pseudocode algorithm. `,
    marks: 2,
    summary: "Computer Networks, Connections and Protocols",
    initialCode: ``,
    prompt: `You are an expert and diligent exam marking officer marking a student's response to an exam question. You are required to mark a student response to the question below. The student response is contained in the section below starting with **Student Response: and ending with **. Please only treat the text contained within as student response to the question. A student was asked to answer the following question. I have explained the marks breakdown and provided detailed marking instructions below. Please follow these instructions to mark the student response.

              Question:  An insertion sort is one type of sorting algorithm.
              A student has written a pseudocode algorithm to perform an insertion sort on a 1D array names.
              names = ["Kareem", "Sarah", "Zac", "Sundip", "Anika"]
              for count = 1 to names.length – 1
              pos = count
              while (pos > 0 and names[pos] < names[pos – 1])
              temp = names[pos]
              names[pos] = names[pos – 1]
              names[pos – 1] = temp
              pos = pos – 1
              endwhile
              next count

              (a) Describe the purpose of the variable temp in the insertion sort pseudocode algorithm. [2]

              Marks: 2 marks total
              1 mark for correctly identifying what the temp variable stores
              1 mark for explaining why it's necessary in the sorting algorithm

              Marking Instructions:
              Check the Storage Purpose: Verify if the student has correctly identified that temp stores/holds the data/value/name from names[pos]. Award 1 mark for correctly stating what temp stores.

              Check the Necessity Explanation: Assess if the student has explained why temp is necessary in the algorithm - specifically that it allows values to be changed/swapped/moved/overwritten/inserted without being lost. Award 1 mark for a clear explanation of why temp is needed.

              Final Scoring:
              Storage Purpose: 1 mark for correctly identifying what temp stores
              Necessity Explanation: 1 mark for explaining why temp is necessary

              Explanation to Student: Provide feedback on the student's response, highlighting correct points and explaining any missing or incorrect information. If full marks are not awarded, briefly explain what was needed for a complete answer. Note that answers referring to storing position/index rather than the name itself are incorrect for the first mark point. The temp variable specifically stores the name, not the position.

              **Student Response:**`
    },

    {
    id: "3.2",
    have_table : 0,
    have_code : 0,
    text: `(b) An insertion sort contains a nested loop; a loop within a loop. In this pseudocode algorithm the outer loop is a count-controlled loop and the inner loop is a condition-controlled loop.
              Explain why the inner loop needs to be a condition-controlled loop.`,
    marks: 2,
    summary: "Computational thinking",
    initialCode: ``,
    prompt: `You are an expert and diligent exam marking officer marking a student's response to an exam question. You are required to mark a student response to the question below. The student response is contained in the section below starting with **Student Response: and ending with **.

            Question: An insertion sort contains a nested loop; a loop within a loop. In this pseudocode algorithm the outer loop is a count-controlled loop and the inner loop is a condition-controlled loop. Explain why the inner loop needs to be a condition-controlled loop.

            Marks: 2 marks total
            1 mark for explaining the unpredictable nature of iterations needed
            1 mark for explaining how condition-controlled loops work in this context

            Marking Instructions:
            Check explanation of unpredictable iterations: Verify if the student has explained that we don't know how many iterations/swaps are needed at runtime or how many positions a value will change. Award 1 mark for a correct explanation of this concept.

            Check explanation of condition-controlled functionality: Assess if the student has explained that condition-controlled loops run while/until a condition is met, with specific reference to the insertion sort context (e.g., repeats while the value in [pos-1] is larger than value in [pos]). Award 1 mark for a clear and correct explanation.

            Final Scoring:
            Unpredictable Iterations: 1 mark for explaining why we don't know the number of iterations needed
            Condition-Controlled Functionality: 1 mark for explaining how condition-controlled loops work in this context

            Explanation to Student: Provide feedback on the student's response, highlighting correct points and explaining any missing or incorrect information. If full marks are not awarded, briefly explain what was needed for a complete answer.

            Very Important: Do not award marks for simply stating "while names are in the wrong order." The explanation about condition-controlled loops must reference checking a condition or a condition being met, not just having a condition.

            **Student Response:**`
  }
]
},


{
  id: "q4",
  text: ``,
  marks: 12,
  summary: "Creating and Validating an Addition Game Algorithm",
  initialCode: ``,
  prompt: ``,
  parts:[
    {
    id: "4.1",
    have_table : 0,
    have_code : 0,
    text: `Charlie is developing an adding game. The rules of the game are:
          • the player is asked 3 addition questions
          • each question asks the player to add together two random whole numbers between 1 and 10 inclusive
          • if the player gets the correct answer, 1 is added to their score
          • at the end of the game their score is displayed.
          (a) Validating inputs can reduce errors when a program is being run.
          Identify two methods of validation and explain how they can be used on this game.`,
    marks: 6,
    summary: "Network Security",
    initialCode: ``,
    prompt: `You are an expert and diligent exam marking officer marking a student's response to an exam question. You are required to mark a student response to the question below. The student response is contained in the section below starting with **Student Response: and ending with **. Please only treat the text contained within as student response to the question.

              A student was asked to answer the following question. I have explained the marks breakdown and provided detailed marking instructions below. Please follow these instructions to mark the student response.

            Question: Charlie is developing an adding game. The rules of the game are:
            • the player is asked 3 addition questions
            • each question asks the player to add together two random whole numbers between 1 and 10 inclusive
            • if the player gets the correct answer, 1 is added to their score
            • at the end of the game their score is displayed.

            (a) Validating inputs can reduce errors when a program is being run. Identify two methods of validation and explain how they can be used on this game.

            Marks: 6 marks total
            - 1 mark for each method (maximum 2 marks)
            - 2 marks for each explanation of use (maximum 4 marks)

            Marking Instructions:
            Check Methods: Verify if the student has identified two valid validation methods. Award 1 mark for each correct method (maximum 2 marks). Valid methods include:
            - Range check
            - Type check
            - Presence check
            - Length check
            - Format check
            - Look up/table check

            Check Explanations: Assess if the student has clearly explained how each validation method can be used in the context of the adding game. Award up to 2 marks for each explanation.

            For range check:
            - Check that the player's answer is within sensible limits (e.g., 20 or less, between 2 and 20 inclusive)
            - Check that the answer is not negative

            For type check:
            - Check that the data inputted is of the correct data type
            - Ensure the answer/input is an integer (whole number)

            For presence check:
            - Check that a value is inputted/not blank
            - Reference to answer/input validation

            For length check:
            - Limit number of characters or check maximum/minimum string length
            - Verify answer/input must be 1 or 2 characters

            For format check:
            - Ensure the data inputted follows a set pattern
            - Check answer/input consists of only 1 or 2 numeric digits

            For look up/table check:
            - Ensure the data inputted is one from an allowed set of values
            - Check that answer/input is one of [2, 3...20] inclusive

            Examples of program code can be accepted, including actual code or identification of technique.

            Additional Marking Guidance:
            - Validation must be applied to the rules of the game as given
            - Do not accept uses related to input not asked for (e.g., names, passwords)
            - Do not accept uses that simply repeat the name of the check
            - For range check, values must be sensible and allow input of 2 to 20
            - For length check, must be clear that the string version of the data input is being checked
            - Accept alternative names or descriptions but name of check must be sensible
            - Mark each answer as a whole, ignore method/use headings
            - Do not accept defensive design elements (e.g., input sanitization, authentication)

            Final Scoring:
            Methods: 2 marks (1 mark for each valid method)
            Explanations: 4 marks (up to 2 marks for each explanation)

            Explanation to Student: Provide feedback on the student's response, highlighting correct points and explaining any missing or incorrect information. If full marks are not awarded, briefly explain what was needed for a complete answer.

            Very Important: Validation must be applied to the context of the adding game. Code examples should demonstrate actual implementation of the validation method.

            **Student Response:**`
  },
  
  {
    id: "4.2",
    have_table : 0,
    have_code : 1,
    text: `(b) Write an algorithm to play this game. The rules are repeated from the start of the question here:
            • the player is asked 3 addition questions
            • each question asks the player to add together two random whole numbers between 1 and 10 inclusive
            • if the player gets the correct answer, 1 is added to their score
            • at the end of the game their score is displayed.`,
    marks: 6,
    summary: "Network Security",
    initialCode: ``,
    prompt: `You are an expert and diligent exam marking officer marking a student's response to an exam question. You are required to mark a student response to the question below. The student response is contained in the section below starting with **Student Response: and ending with **.
Question: Write an algorithm to play this game. The rules are:
- The player is asked 3 addition questions
- Each question asks the player to add together two random whole numbers between 1 and 10 inclusive
- If the player gets the correct answer, 1 is added to their score
- At the end of the game their score is displayed.

Marks: 6 marks total

Marking Instructions:
Award 1 mark for each of the following elements (maximum 6 marks):

1. Initializing/declaring score variable (to zero) before use, outside of any loop
2. Generating 2 random numbers between 1 and 10
3. Inputting answer from user with appropriate prompt showing the numbers
4. Checking if the input matches the correct answer
5. Adding 1 to the score if the answer is correct
6. Repeating the process three times (either using a loop or writing the code three times)

Critical Marking Notes:
- For bullet point 2: Must generate random numbers in the range 1-10 inclusive
- For bullet point 3: Must use the generated random numbers in the prompt
- For bullet point 4: Must compare the user input with the actual sum of the random numbers
- For bullet point 5: Score increment must be conditional on a correct answer
- For bullet point 6: If using a loop, it must repeat exactly 3 times
- If code is repeated 3 times (no loop), each section must use different random numbers

Do NOT award marks for:
- Using the same numbers for all three questions
- Missing initialization of the score variable
- Incrementing score regardless of correct/incorrect answers
- Prompting for input without showing the numbers to add

Acceptable variations:
- Different programming styles/syntaxes
- Different variable names
- Different output formatting for the final score
- Minor syntax errors that don't affect the logic

Final Scoring:
Total marks: Sum of points earned for each bullet point (maximum 6)

Explanation to Student: Provide feedback on which algorithm elements were correctly implemented and which were missing or incorrect. If marks were deducted, explain exactly what was needed to receive those marks.

**Student Response:**`
  }
]
},

{
  id: "q5",
  text: ``,
  marks: 20,
  summary: "Programming and Algorithms for a Security Alarm System",
  initialCode: ``,
  prompt: ``,
  parts:[
    {
    id: "5.1",
    have_table : 1,
    have_code : 0,
    text: `OCR Security Services is a company that installs intruder alarm systems in commercial buildings.
          The systems use a computer that is connected to the door sensors and window sensors.
          The following data is stored in the system:
          [Display image3: \\src\\assets\\1.png]
          (a) Below is a table showing some variables within the program.
 Choose one box in each row to identify the most appropriate data type for each variable.
 [Display image4: \\src\\assets\\1.png]`,
    marks: 4,
    summary: "Systems Software",
    initialCode: ``,
    prompt: `You are an expert and diligent exam marking officer marking a student's response to an exam question. You are required to mark a student response to the question below. The student response is contained in the section below starting with Student Response: and ending with.
 
              Question: OCR Security Services is a company that installs intruder alarm systems in commercial buildings. The systems use a computer that is connected to the door sensors and window sensors.

              The following data is stored in the system:
              (a) Below is a table showing some variables within the program.
              Choose one box in each row to identify the most appropriate data type for each variable.

              Variable | Boolean | Char | String | Integer | Real
              ---------|---------|------|--------|---------|------
              UserName |         |      |        |         |
              EmergencyPhoneNumber |    |      |        |         |
              DoorSensorActive |    |      |        |         |
              DoorActiveTime |    |      |        |         |

              Marks: 4 marks total
              1 mark for each correctly identified data type

              Marking Instructions:
              Check each row independently and award 1 mark for each correct data type identification:
              - UserName: Verify if the student correctly identified this as a String data type
              - EmergencyPhoneNumber: Verify if the student correctly identified this as a String data type
              - DoorSensorActive: Verify if the student correctly identified this as a Boolean data type
              - DoorActiveTime: Verify if the student correctly identified this as an Integer data type

              No mark if more than one data type is selected in a row.
              Allow other indications of choice (e.g. cross) as long as it's clear.

              Final Scoring:
              - UserName data type: 1 mark
              - EmergencyPhoneNumber data type: 1 mark
              - DoorSensorActive data type: 1 mark
              - DoorActiveTime data type: 1 mark

              Explanation to Student: Provide feedback on the student's response, highlighting correct identifications and explaining any incorrect selections. For incorrect selections, explain why the chosen data type is inappropriate and which would be more suitable. If full marks are not awarded, briefly explain what was needed for a complete answer, focusing on the properties of each data type and their suitability for the given variables.

              **Student Response:**`
  },
  
  {
    id: "5.2",
    have_table : 0,
    have_code : 1,
    text: `(b) The alarm has an algorithm that decides whether to sound the alarm by checking the data that is stored in the following three variables.
• SystemArmed
• DoorSensorActive
• WindowSensorActive
 The alarm will only sound when the alarm has been activated and one or both of the door and window sensors are activated. When the system needs to sound the alarm it calls the pre-written procedure SoundAlarm()
 Write a program that checks the data in the variables and calls SoundAlarm() when appropriate.
 You must use either:
• OCR Exam Reference Language, or
• A high-level programming language that you have studied.`,
    marks: 4,
    summary: "Systems Software",
    initialCode: ``,
    prompt: `You are an expert and diligent exam marking officer marking a student's response to an exam question. You are required to mark a student response to the question below. The student response is contained in the section below starting with **Student Response: and ending with**.
            Question: The alarm has an algorithm that decides whether to sound the alarm by checking the data that is stored in the following three variables:
            - SystemArmed
            - DoorSensorActive
            - WindowSensorActive

            The alarm will only sound when the alarm has been activated and one or both of the door and window sensors are activated. When the system needs to sound the alarm it calls the pre-written procedure SoundAlarm()

            Write a program that checks the data in the variables and calls SoundAlarm() when appropriate. You must use either:
            - OCR Exam Reference Language, or
            - A high-level programming language that you have studied.

            Marks: 4 marks total

            Marking Instructions:
            Award 1 mark for each of the following elements:

            1. Appropriate use of selection/conditional structure (if statement, case statement, etc.)
            2. Correctly checking if the system is armed
            3. Correctly checking if either door sensor OR window sensor is active (must check both sensors)
            4. Correctly calling SoundAlarm() only when both conditions are met

            Critical Marking Notes:
            - The program must call SoundAlarm() ONLY when:
              * SystemArmed is true/active AND
              * At least one of DoorSensorActive or WindowSensorActive is true/active
            - Both sensor checks must be present and correctly combined with OR logic
            - The system armed check must be correctly combined with the sensor checks using AND logic
            - For bullet point 4, verify that SoundAlarm() is called in all appropriate situations and not called in inappropriate situations

            Valid Approaches:
            - Nested if statements
            - Single if statement with compound condition
            - Multiple separate if statements with appropriate conditions
            - While loops with appropriate conditions (instead of if statements)

            Common Errors (do NOT award full marks for):
            - Missing parentheses that change the logical meaning in compound conditions
            - Using AND instead of OR between sensor checks
            - Using OR instead of AND between SystemArmed and sensor checks
            - Not checking both sensors
            - Calling SoundAlarm() unconditionally
            - Incorrect logical structure that doesn't match the problem statement

            Final Scoring:
            Total marks: Sum of points earned (maximum 4)

            Explanation to Student: Provide feedback on the logical structure of their code and whether it correctly implements all the required conditions. If marks were deducted, explain the logical errors in their solution and how to fix them.

            **Student Response:**`
  },
  
  {
    id: "5.3",
    have_table : 1,
    have_code : 0,
    text: `(c) The alarm system can also have motion sensors. Each type of sensor has a code. The code for each sensor is given in the table:
            [Display image5: \\src\\assets\\1.png]
          A program is written to reset the sensors. The program:
          • asks the user to enter the code for the sensor they want to reset
          • calls the prewritten function CheckSensorCode() to check whether the code entered is a valid code
          • the sensor number is read as input if the code is valid and the function
          • ResetSensor() is called for the sensor
          01 sensorType = input("Enter code of the type of sensor to reset")
          02 if(CheckSensorCode(sensorType)) then
          03 sensorNumber = input("Please input the number of the sensor to reset")
          04 sensorID = sensorType + sensorNumber
          05 ResetSensor(sensorID)
          06 endif
          (i) Give the identifier of a variable used in the program.
          (ii) Identify the data type of the data returned by the function CheckSensorCode() 
          (iii) Give the line number that contains a function call.`,
    marks: 3,
    summary: "Systems Software",
    initialCode: ``,
    prompt: `You are an expert and diligent exam marking officer marking a student's response to an exam question. You are required to mark a student response to the question below. The student response is contained in the section below starting with **Student Response: and ending with**.
            Question: The alarm system can also have motion sensors. Each type of sensor has a code. The code for each sensor is given in the table:

            | Code | Sensor |
            |------|--------|
            | MS   | Motion sensor |
            | DS   | Door sensor |
            | WS   | Window sensor |

            A program is written to reset the sensors. The program:
            • asks the user to enter the code for the sensor they want to reset
            • calls the prewritten function CheckSensorCode() to check whether the code entered is a valid code
            • the sensor number is read as input if the code is valid and the function ResetSensor() is called for the sensor

            
            01 sensorType = input("Enter code of the type of sensor to reset")
            02 if(CheckSensorCode(sensorType)) then
            03   sensorNumber = input("Please input the number of the sensor to reset")
            04   sensorID = sensorType + sensorNumber
            05   ResetSensor(sensorID)
            06 endif
            

            (i) Give the identifier of a variable used in the program. [1 mark]

            (ii) Identify the data type of the data returned by the function CheckSensorCode() [1 mark]

            (iii) Give the line number that contains a function call. [1 mark]

            Marks: 3 marks total (1 mark for each part)

            Marking Instructions:

            For part (i):
            - Award 1 mark for identifying any ONE of these variables:
              * sensorType
              * sensorNumber
              * sensorID
            - Do not penalize for differences in case, spacing, or minor misspellings
            - No mark for identifying anything that is not a variable (e.g., function names)

            For part (ii):
            - Award 1 mark for identifying the data type as:
              * Boolean
              * Bool
            - Accept minor misspellings (e.g., "Boolen", "Booleen")
            - No mark for any other data type

            For part (iii):
            - Award 1 mark for identifying any ONE of these line numbers:
              * Line 01 (input function)
              * Line 02 (CheckSensorCode function)
              * Line 03 (input function)
              * Line 05 (ResetSensor function)
            - The line number must be clearly stated
            - No mark for line 04 or line 06 as they don't contain function calls

            Final Scoring:
            - Part (i): 1 mark for correctly identifying a variable
            - Part (ii): 1 mark for correctly identifying the data type as Boolean
            - Part (iii): 1 mark for correctly identifying a line number with a function call
            - Total: 3 marks maximum

            Explanation to Student: Provide targeted feedback for each part of the question. For incorrect answers, explain what the correct answer should be and why. For correct answers, affirm the student's understanding of programming concepts.

            **Student Response:**`
  },
  
  {
    id: "5.4",
    have_table : 0,
    have_code : 0,
    text: `(d) The alarm system has a log that stores a record each time a sensor is triggered. This is called an event. The record format is given in the table:
            [Display image6: \\src\\assets\\1.png]

            Write an SQL statement to display the sensor IDs of the door sensors that have been triggered for more than 20 seconds.`,
    marks: 3,
    summary: "Systems Software",
    initialCode: ``,
    prompt: `You are an expert and diligent exam marking officer marking a student's response to an exam question. You are required to mark a student response to the question below. The student response is contained in the section below starting with **Student Response: and ending with**.
Question: Alex manages a small business using his laptop computer. His daily operations depend on different types of system software. Alex routinely uses a backup utility to carry out both full and incremental backups. Explain the reasons why Alex carries out both full and incremental backups.
Marks: 3 marks total
Marking Instructions:

Award 1 mark for explaining that full backup copies every file and all data.
Award 1 mark for stating that incremental backup only copies files/data that have changed.
Award 1 additional mark for including any ONE of these elaborations:

Incremental backups can only be done once a full backup has been completed
Incremental backups reduce time taken to backup each time
Incremental backups reduce storage/memory used for backup



Critical Marking Notes:

The exact wording is not necessary, but the core concept must be present
To achieve full marks (3/3), the response must cover points 1 and 2, plus any one elaboration from point 3
If multiple elaborations from point 3 are given, award the mark for the first correct one only
Do not award marks for information not directly related to the question or for implied/assumed information

Final Scoring:
Answer Mark: Up to 3 marks total, based on the structure outlined above.
Explanation to Student: Provide specific feedback on the answer. Indicate which points were correctly explained and which were missing or incorrect. Clearly state why the given marks were awarded, referencing the marking structure.

**Student Response:**`
  },
  
  {
    id: "5.5",
    have_table : 0,      
    have_code : 1,
    text: `(e) OCR Security Services need to identify the total number of seconds the sensors have been activated on a specific date.
          The data from the database table events is imported into the program written in a highlevel programming language.
          The program stores the data in a two-dimensional (2D) string array with the identifier arrayEvents
          The data to be stored is shown in the table. 
          [Display image8: \\src\\assets\\1.png]
          In this table, the value of events[1, 1] contains "MS1".

          Write a program that:
          • asks the user to input a date
          • totals the number of seconds sensors have been activated on the date input
          • outputs the calculated total in an appropriate message including the date, for example: Sensors were activated for 40 seconds on 05/02/2023
          You must use either:
          • OCR Exam Reference Language, or
          • A high-level programming language that you have studied.`,
    marks: 6,
    summary: "Systems Software",
    initialCode: ``,
    prompt: `You are an expert and diligent exam marking officer marking a student's response to an exam question. You are required to mark a student response to the question below. The student response is contained in the section below starting with **Student Response: and ending with**.
          Question: OCR Security Services need to identify the total number of seconds the sensors have been activated on a specific date. The data from the database table events is imported into the program written in a high-level programming language. The program stores the data in a two-dimensional (2D) string array with the identifier arrayEvents.

          The data to be stored is shown in the table. In this table, the value of events[1, 1] contains ""MS1"".

          | Date       | SensorID | SensorType | Length |
          |------------|----------|------------|--------|
          | 05/02/2023 | WS2      | Window     | 38     |
          | 05/02/2023 | MS1      | Motion     | 2      |
          | 06/02/2023 | DS3      | Door       | 1      |
          | 06/02/2023 | MS2      | Motion     | 3      |
          | 06/02/2023 | MS1      | Motion     | 2      |
          | 07/02/2023 | WS1      | Window     | 24     |
          | 07/02/2023 | DS1      | Door       | 1      |

          Write a program that:
          - asks the user to input a date
          - totals the number of seconds sensors have been activated on the date input
          - outputs the calculated total in an appropriate message including the date, for example:
            Sensors were activated for 40 seconds on 05/02/2023

          You must use either:
          - OCR Exam Reference Language, or
          - A high-level programming language that you have studied.

          Marks: 6 marks total

          Marking Instructions:
          Award 1 mark for each of the following elements (maximum 6 marks):

          1. Inputting date and storing in a variable (or using directly)
          2. Accessing all events in the array (either using a loop or manually referencing each row)
          3. Using appropriate selection structure to filter events
          4. Correctly comparing the input date with the date in the array (element 0)
          5. Adding the length value (element 3) to a running total when dates match
          6. Outputting the calculated total and date in an appropriate message at the end

          Critical Marking Notes:
          - For bullet point 2: Must access all seven events (indices 0 to 6) in the array
          - For bullet point 3: Must use appropriate selection (e.g., if statement) for filtering
          - For bullet point 4: Must correctly access the date element (first column) in each row
          - For bullet point 5: Must correctly access the length element (fourth column) and add to running total
          - For bullet point 6: Final output must include both the calculated total and the input date

          Acceptable variations:
          - Array can be accessed using either row-major or column-major notation
          - Loop can be implemented as for-loop, while-loop, or foreach-type construct
          - Manual access of each row (without loops) is acceptable
          - Total initialization can be at beginning or within the process
          - Output can occur once at the end or within the loop (as long as final output is correct)
          - Different variable names are acceptable
          - Different string formatting/concatenation methods are acceptable

          Do NOT award marks for:
          - Incorrect array indexing that would not access all events
          - Missing total initialization
          - Incorrect comparison between input date and stored dates
          - Adding values other than the length to the total
          - Missing output of either the total or the date

          Final Scoring:
          Total marks: Sum of points earned for each bullet point (maximum 6)

          Explanation to Student: Provide feedback on which program elements were correctly implemented and which were missing or incorrect. If marks were deducted, explain exactly what was needed to receive those marks.

          **Student Response:**`
  }
]
}
];

export default questions;
